import BreadcrumbProvider from './hooks/useBreadcrumb';

import { BreadcrumbProps } from './@types/BreadcrumbProps';
import Container from './handles/Container';
import HomeLink from './handles/HomeLink';
import Arrow from './handles/Arrow';
import TermArrow from './handles/TermArrow';
import Term from './handles/Term';

import './Breadcrumb.scss';
import Link from './handles/Link';

const Breadcrumb = (props: BreadcrumbProps) => (
	<BreadcrumbProvider {...props}>
		<Container>
			<HomeLink />

			<Arrow>
				<Link>Category</Link>
			</Arrow>

			<TermArrow />

			<Term>Produto</Term>
		</Container>
	</BreadcrumbProvider>
);

export default Breadcrumb;
